var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pharmacy-filled_svg__clip0_507_17781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.665 3.757l-2.454 4.25h-5.776l3.9-6.75.017-.028a2.499 2.499 0 114.313 2.528z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.007h22a1 1 0 011 1 11.947 11.947 0 01-6 10.383v1.617a1 1 0 01-1 1H7a1 1 0 01-1-1V21.39a11.947 11.947 0 01-6-10.383 1 1 0 011-1zm14.854 7.846A.5.5 0 0016 17.5v-1a.5.5 0 00-.5-.5H13v-2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V16H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V18h2.5a.5.5 0 00.354-.147z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pharmacy-filled_svg__clip0_507_17781"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgPharmacyFilled;